exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body[data-v-29f29050]{padding:.5rem}", ""]);

// exports
